const buttonGrayCss = 'background: linear-gradient(90deg, #f1f3f7, #f1f3f3);'
const buttonGreenCss = 'background: linear-gradient(90deg, #aaf5d4, #7ce0d6);'

export { buttonGrayCss, buttonGreenCss }
